var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24243 21.6C2.97909 21.6 2.80353 21.5131 2.62796 21.3393C2.36462 21.0787 2.36462 20.8181 2.4524 20.4706L3.76912 16.1267C3.94468 15.4316 4.38358 14.6497 4.99805 14.1285L15.6196 3.4425C16.3218 2.74747 17.1996 2.39996 18.1652 2.39996C19.043 2.39996 19.9208 2.74747 20.6231 3.35562C21.9398 4.65879 21.9398 6.91761 20.5353 8.30766L11.5816 17.2561C11.2305 17.6036 10.7038 17.6036 10.3527 17.2561C10.0016 16.9086 10.0016 16.3873 10.3527 16.0398L19.3064 7.17824C20.0086 6.48322 20.0964 5.26693 19.3941 4.57191C19.043 4.2244 18.6041 4.05064 18.1652 4.05064C17.6385 4.05064 17.1996 4.2244 16.7607 4.65879L6.31477 15.0841L9.3871 18.1249C9.56266 18.2986 9.65045 18.5592 9.65045 18.8199C9.65045 19.0805 9.47488 19.3411 9.29932 19.428L9.12376 19.5149C8.68485 19.7755 8.24595 20.0362 7.71926 20.2099L3.41799 21.5131C3.33021 21.6 3.33021 21.6 3.24243 21.6ZM5.43696 16.4742C5.43696 16.5611 5.43696 16.5611 5.34918 16.6479L4.47137 19.5149L7.28036 18.6461C7.36814 18.6461 7.36814 18.6461 7.45592 18.5592L5.43696 16.4742Z",
    fill: "#6A4E42",
    stroke: "#6A4E42",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIcon);
export default __webpack_public_path__ + "static/media/general-icon.16f851e7ec62ad3a9690415ab909d9a9.svg";
export { ForwardRef as ReactComponent };